<template>
  <div v-if="liveReceipt" class="card card-custom overflow-hidden">
    <div class="card-body p-0">
      <!-- begin: header-->
      <div class="row justify-content-center px-8 px-md-0 py-6 py-md-10">
        <div class="col-md-9">
          <div
            class="d-flex justify-content-between pb-10 pb-md-20 flex-column flex-md-row"
          >
            <h1 class="display-6 font-weight-boldest mt-2 mb-8">
              کد
              <span class="btn btn-outline-primary font-size-lg p-2 px-5">
                {{ liveReceipt.id }}
              </span>
              <span class="mt-3 d-block opacity-70 font-size-xs"></span>
            </h1>
            <div class="d-flex flex-column align-items-md-end px-0">
              <div class="max-w-150px text-center">
                <img
                  class="mx-auto w-100"
                  src="/media/logos/logo.png"
                  alt="mirol"
                />
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between mb-15">
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">نام کاربر </span>
              <span class="opacity-70">
                {{ getFullName }}
              </span>
            </div>
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">نوع رسید</span>
              <span class="opacity-70 text-nowrap"> میرول - رسید پخش </span>
            </div>
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">تاریخ</span>
              <span dir="ltr" class="opacity-70 text-nowrap font-family-base">
                {{ formatDate(liveReceipt["created_at"]) }}
              </span>
            </div>
          </div>

          <div class="border-bottom w-100">مشخصات</div>
          <div class="d-flex justify-content-between pt-5">
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">نام برنامه‌</span>
              <span class="opacity-70 text-nowrap">
                <router-link
                  :to="{
                    name: 'programs-show',
                    params: { id: liveReceipt.program_id }
                  }"
                >
                  {{ liveReceipt.program ? liveReceipt.program.name : "" }}
                </router-link>
              </span>
            </div>
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">کد پخش</span>
              <span class="opacity-70">
                <router-link
                  :to="{
                    name: 'lives-show',
                    params: {
                      program: liveReceipt.program_id,
                      live: liveReceipt.live_id
                    }
                  }"
                >
                  {{ liveReceipt.live_id }}
                </router-link>
              </span>
            </div>
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">طول پخش</span>
              <span class="opacity-70">
                {{
                  prettyTime(
                    liveReceipt.program ? liveReceipt.items.live_length : ""
                  )
                }}
              </span>
            </div>
            <div v-if="liveReceipt.items" class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">قیمت پخش</span>
              <span class="opacity-70">
                {{ numberFormat(liveReceipt.items.live_price) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- end: header-->

      <!-- begin: body-->
      <div
        v-if="liveReceipt.items && liveReceipt.items.free_destinations.length"
        class="row justify-content-center py-8 px-8 py-md-10 px-md-0"
      >
        <div class="col-md-9">
          <div
            v-if="liveReceipt.items.free_destinations.length"
            class="table-responsive"
          >
            <table class="table">
              <thead>
                <tr>
                  <th class="pl-0 font-weight-bold text-muted text-uppercase">
                    مقصد‌های رایگان
                  </th>
                  <th class="text-right font-weight-bold text-muted">زمان</th>
                  <th class="text-right pr-0 font-weight-bold text-muted">
                    قیمت (ریال)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="freeDestination in liveReceipt.items.free_destinations"
                  :key="freeDestination.id"
                  class="font-weight-boldest border-bottom-0"
                >
                  <td class="pl-0 pt-7">{{ freeDestination.name }}</td>
                  <td class="text-right pt-7">
                    {{ prettyTime(freeDestination.length) }}
                  </td>
                  <td class="text-right pt-7">
                    {{ numberFormat(freeDestination.price) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="liveReceipt.items.paid_destinations"
            class="table-responsive mt-10"
          >
            <table class="table">
              <thead>
                <tr>
                  <th class="pl-0 font-weight-bold text-muted text-uppercase">
                    مقصد‌های غیر رایگان
                  </th>
                  <th class="text-right font-weight-bold text-muted">زمان</th>
                  <th class="text-right pr-0 font-weight-bold text-muted">
                    قیمت (ریال)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="destination in liveReceipt.items.paid_destinations"
                  :key="destination.id"
                  class="font-weight-boldest border-bottom-0"
                >
                  <td class="pl-0 pt-7">{{ destination.name }}</td>
                  <td class="text-right pt-7">
                    {{ prettyTime(destination.length) }}
                  </td>
                  <td class="text-right pt-7">
                    {{ numberFormat(destination.price) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- end: body-->

      <!-- begin: footer-->
      <div
        class="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0"
      >
        <div v-if="liveReceipt.items" class="col-md-9">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th
                    class="font-weight-bold text-muted text-center text-uppercase"
                  >
                    مجموع (ریال)
                  </th>
                  <th
                    class="font-weight-bold text-muted text-center text-uppercase"
                  >
                    مبلغ قابل پرداخت (ریال)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="font-weight-bolder">
                  <td class="text-center">
                    {{ numberFormat(liveReceipt.items.sum) }}
                  </td>
                  <td
                    class="text-danger font-size-h3 font-weight-boldest text-center"
                  >
                    {{ numberFormat(liveReceipt.items.sum) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- end: footer-->

      <!-- begin: action-->
      <!-- end: action-->
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_LIVE_RECEIPT } from "@/core/services/store/receipts/live.module";
import { mapGetters } from "vuex";

export default {
  name: "liveReceiptsShow",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "رسیدها", route: { name: "receipts-lives-index" } },
      { title: ` رسید شماره ${this.$route.params.id}` }
    ]);
    this.$store.dispatch(FETCH_LIVE_RECEIPT, this.$route.params.id).then(() => {
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "چاپ رسید",
            event: "print-receipt-event",
            class: "btn-primary"
          }
        ],
        links: [
          {
            name: "پخش",
            to: {
              name: "lives-show",
              params: {
                program: this.liveReceipt.program_id,
                live: this.liveReceipt.live_id
              }
            }
          }
        ]
      });
    });

    this.eventHub.$on("print-receipt-event", () => {
      window.print();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("print-receipt-event");
  },
  computed: {
    ...mapGetters(["liveReceipt"]),

    getFullName() {
      return this.gFullName(this.liveReceipt.user);
    }
  }
};
</script>
